// import React, { useState, Fragment, Component } from 'react'
// import React, { Fragment, useState, Component, useRef, useEffect } from "react"

import React, { Fragment, useState, Component, useRef, useEffect} from "react"

import moment from "moment"
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams, Redirect } from "react-router-dom"
import { withRouter } from "react-router";
import { AvField, AvForm} from "availity-reactstrap-validation"
import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar';
import Tabledetailpresensi from '../Detail/Components/TableDetailComponent'
import CustomSelect from "../../GlobalComponents/CustomSelect";
import Select from "../../../../helpers/ui/CustomSelect";
import SimulationComponent from '../Detail/Components/SimulationComponent'
import SimulationHonorerComponent from '../Detail/Components/SimulationHonorerComponent'
import SimulationPTSPComponent from "./Components/SimulationPTSPComponent";

var reformatOptions = function(raw, label, value) {
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
  
      return newObj;
    });
};
const createYearOption = (startYear = 2000) => {
    var currentYear = new Date().getFullYear() + 10, years = [];
      startYear = startYear || 1980;  
      while ( startYear <= currentYear ) {
          var newObj = {};
          var year = startYear++;
          newObj["label"] = year;
          newObj["value"] = year;
          years.push(newObj);
      }   
      return years;
}
  
const createMonthOptions = () => {
      var months = [
          "Januari",
          "Februari",
          "Maret",
          "April",
          "Mei",
          "Juni",
          "Juli",
          "Agustus",
          "September",
          "Oktober",
          "November",
          "Desember",
      ];
  
      return months.map(function(month, i) {
          var newObj = {};
          newObj["label"] = month;
          newObj["value"] = ++i;
  
          return newObj;
      });
}

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {
            start_date : moment().startOf('month').format('YYYY-MM-DD'),
            end_date : moment().endOf('month').format('YYYY-MM-DD'),
            // start_date : '',
            // end_date : '',
            yearOptions: createYearOption(new Date().getFullYear() - 30),
            monthOptions: createMonthOptions(),
            year: new Date().getFullYear(),
            month: moment().format('M'),
            employeeListOption: null,
            employeeuuid: '',
            selectedEmployee: {},
            redirect: null
        }

        this.activeRef =  React.createRef()
    }
    
    componentDidMount() {
        // const activeRef = useRef();
        this.detailBloc.fetchDetail({uuid: this.props.uuid})
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            detail: response,
                            selectedEmployee: {label: response.employee_full_name, value: response.employee_uuid}
                        })
                        if(this.state.redirect == true){
                            this.handleButtonSearch()
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)

        this.detailBloc.exportChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    this.setState({
                        loading: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    //window.location.href = link.file_url
                    this.setState({
                        loading: false,
                        success: true
                    })
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1000);
                    break
                case apiResponse.ERROR:
                    this.setState({
                        urlFileDetail: link,
                        loading: false,
                        failed: true
                    })
                    setTimeout(function() {
                        this.setState({
                            failed: false,
                        })
                    }, 1000)
                    break
                default:
                    break
            }
        })

        this.detailBloc.employeeListChannel.subscribe((result) => {
            switch (result.status) {
              case apiResponse.COMPLETED:
                // this.setState({
                //   employeeListOption: result.data?.response?.result,
                // });
                this.setState({
                    employeeListOption: (result.data?.response?.result || []).map(data => ({
                        label: `${data.employee_name} - ${data.employee_nip}`,
                        value: data.employee_uuid
                    }))
                })
                break;
              case apiResponse.ERROR:
                break;
              default:
                break;
            }
        });
        this.detailBloc.fetchEmployeeList();
    }

    reset = () =>
    {
        this.setState({start_date:'', end_date:''})
    }

    reloadActiveRef = () => this.activeRef.current.setTokenAPI()

    handleButtonSearch = () => {
        this.reloadActiveRef();
    }
    handleEmployeeChange = () => {
        this.detailBloc.fetchDetail({uuid: this.state.employeeuuid})
        
    }
    handleButtonExport = () => {
        this.setState({loading: true})
        var filter = this.props.filter
        this.detailBloc.fetchExport({
            uuid: this.props.uuid, 
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            nip : this.state.detail.employee_nip,
            nama :this.state.detail.employee_full_name,
            jabatan : this.state.detail.employee_current_position_name,
            unit: this.state.detail.employee_current_work_unit_name
        });
    }

    render() {

        // const [nip, start_date] = useState('')
        // const [name, end_date] = useState('')

        // function handleButtonReset() {
        //     start_date('');
        //     end_date('');
        // }

        let filter = {
            // year: this.state.year,
            // month: this.state.month,
            start_date: this.state.start_date,
            end_date: this.state.end_date
        }

        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            {/* <PegawaiSideBar active="riwayatsumpah"/> */}

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Data Presensi</CardTitle>
                                    <CardSubtitle className="mb-1">
                                        Informasi Detail Data Presensi 
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        // onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_nip !== "" ? this.state.detail.employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="4">
                                                {/* {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_full_name !== "" ? this.state.detail.employee_full_name : '-'}</>
                                                    : <Shimmer><div style={{width: '60%', height: 15}}></div></Shimmer>
                                                } */}
                                                <CustomSelect 
                                                    name="employee_uuid"
                                                    errorMessage="Pilih Pegawai"
                                                    options={this.state.employeeListOption} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Pegawai"
                                                    defaultValue={this.state.detail?.employee_uuid}
                                                    onChange={(v) =>{ 
                                                        this.setState({employeeuuid: v.value, redirect: true}, () => {
                                                            this.handleEmployeeChange();
                                                        });
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_current_position_name !== "" ? this.state.detail.employee_current_position_name : '-'}</>
                                                    : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Unit Kerja
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_current_work_unit_name !== "" ? this.state.detail.employee_current_work_unit_name : '-'}</>
                                                    : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Periode Mulai
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="start_period"
                                                    placeholder="Periode Mulai..."
                                                    type="date"
                                                    errorMessage="Masukkan Periode Mulai"
                                                    className="form-control"
                                                    onChange={event => this.setState({start_date:event.target.value})}
                                                    id="start_period"
                                                    value={this.state.start_date}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Periode Akhir
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="end_period"
                                                    placeholder="Periode Akhir..."
                                                    type="date"
                                                    errorMessage="Masukkan Periode Akhir"
                                                    className="form-control"
                                                    onChange={event => this.setState({end_date:event.target.value})}
                                                    id="end_period"
                                                    value={this.state.end_date}
                                                    min={this.state.start_date}
                                                    validate={{
                                                        min: { value: this.state.start_date, errorMessage: 'Periode akhir tidak boleh kurang dari periode mulai' }
                                                    }}
                                                />
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Bulan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <CustomSelect 
                                                    name="period_month"
                                                    errorMessage="Pilih Bulan"
                                                    options={this.state.monthOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Bulan"
                                                    defaultValue={this.state.month}
                                                    onChange={(v) => this.setState({month: v.value})}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tahun <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <CustomSelect 
                                                    name="period_year"
                                                    errorMessage="Pilih Tahun"
                                                    options={this.state.yearOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Tahun"
                                                    defaultValue={this.state.year}
                                                    onChange={(v) => this.setState({year: v.value})}
                                                />
                                            </Col>
                                        </Row> */}

                                        <Col md="12">
                                            <Button 
                                                color="primary" 
                                                type="button"
                                                onClick={() => {
                                                    this.handleButtonSearch()
                                                }}
                                            >
                                                <i className="uil-search-alt"></i> Cari
                                            </Button>
                                            {' '}
                                            <Button 
                                            color="success" 
                                            type="button"
                                            onClick={() => {
                                                this.handleButtonExport()
                                                }}
                                            >
                                                <i className="uil-file"></i> Export
                                            </Button>
                                            <div className="p-2 bd-highlight float-end">
                                                <div style={{paddingTop: 8}}>
                                                    <i className="bx bx-mobile-alt"></i> Absensi Mobile
                                                </div>
                                            </div>
                                            <div className="p-2 bd-highlight float-end">
                                                <div style={{paddingTop: 8}}>
                                                    <i className="bx bx-fingerprint"></i> Absensi Mesin
                                                </div>
                                            </div>
                                        </Col>
                                    <hr></hr>

                                    <Col >

                                        {
                                            this.state.detail ?
                                                <>
                                                {
                                                    this.state.detail.employee_status_name.includes('Honorer') ? 
                                                        <SimulationHonorerComponent ref={this.activeRef} uuid={this.props.uuid} filter={filter} handleInactiveSuccess={() => this.reloadActiveRef()}/>
                                                    : 
                                                        this.state.detail.employee_current_work_unit_name.includes('PTSP') ?
                                                            <SimulationPTSPComponent ref={this.activeRef} uuid={this.props.uuid} filter={filter} handleInactiveSuccess={() => this.reloadActiveRef()}/>
                                                        :
                                                            <SimulationComponent ref={this.activeRef} uuid={this.props.uuid} filter={filter} handleInactiveSuccess={() => this.reloadActiveRef()}/>
                                                }
                                                </>
                                            : <Shimmer><div style={{width: '100%', height: 15}}></div></Shimmer>
                                        }

                                      
                                    </Col>
                                                                            
                                        <Row className="mb-1">
                                            <Col md="3"></Col>
                                            {/* <Col md="9"> */}
                                                <Link to="/kepegawaian/presensi.html?" className="waves-effect">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                            {/* </Col> */}
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/presensi.html?detail&uuid=${this.state.employeeuuid}`} />
                : null }
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);